import React, { useCallback } from 'react'
import { useDrag } from 'react-dnd'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import BeneIcon from 'custom/assets/common-icons/bene-image.svg'
import { Col } from 'react-bootstrap'

export default function BeneficiaryGridItem({ beneDetails, linkPath, transferType = '' }) {
  const history = useHistory()
  const dispatch = useDispatch()
  const [{ isDragging }, drag] = useDrag({
    item: { beneDetails, type: 'BeneficiaryGridItem' },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult()
      if (item && dropResult) {
        console.log(beneDetails)
        history.push({
          pathname: linkPath,
          state: {
            beneDetails: beneDetails,
            transferType: transferType,
          },
        })
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const handleBeneficiaryClick = useCallback(() => {
    history.push({
      pathname: linkPath,
      state: {
        beneDetails: beneDetails,
        transferType: transferType,
      },
    })
  })
  const opacity = isDragging ? 0.4 : 1
  return (
    <Col
      ref={drag}
      style={{ opacity }}
      onClick={() => handleBeneficiaryClick()}
      xs={'auto'}
      sm={'auto'}
      md={'auto'}
      className='bene-card'>
      {transferType !== 'OAT' && (
        <>
          <img
            style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
            src={beneDetails?.image === null ? BeneIcon : beneDetails?.image}
          />
          <span>{beneDetails?.shortName}</span>
        </>
      )}

      {transferType === 'OAT' && (
        <>
          <img
            style={{ height: 30, width: 30, margin: '0 auto', objectFit: 'contain' }}
            src={BeneIcon}
          />
          <span>{beneDetails?.accountNo}</span>
        </>
      )}
    </Col>
  )
}
